import styled from 'styled-components';
import { Box, Typography, Button, Paper } from '@mui/material';

export const Container = styled(Box)`
  padding: 24px;
  position: relative;
`;

export const ContentWrapper = styled(Box)`
  margin: 0 auto;
`;

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  color: #333;
`;

export const CreateButton = styled(Button)`
  background-color: #6a3a87;
  color: #fff;
  width: 150px;
  height: 45px;
  border-radius: 4px;
`;

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
`;

export const MessageText = styled(Typography)`
  color: #8e8e8d;
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

// Card
export const CardContainer = styled(Paper)`
  background-color: #fff;
  padding: 16px 24px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  flex: 1;
`;

export const CardItem = styled.div<{ $withBorder?: boolean }>`
  display: flex;
  gap: 30px;
  width: 100%;
  max-width: 250px;
  align-items: center;
  margin-left: ${props => (props.$withBorder ? '30px' : 'none')};
  padding-left: ${props => (props.$withBorder ? '10px' : 'none')};
  border-left: ${props => (props.$withBorder ? '1px solid #ddd' : 'none')};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 20px;
`;

export const FuncButton = styled(Button)`
  background-color: #1a8754;
  color: #fff;
  width: 70px;
  height: 38px;
  border-radius: 4px;
  &:hover {
    background-color: #157347;
  }
`;

export const Divider = styled.span`
  color: #ddd;
`;
